import o from "./highrise195.mjs";
/* empty css             */
import r from "./highrise181.mjs";
const p = /* @__PURE__ */ r(o, [["__scopeId", "data-v-02cd816c"]]);
export {
  p as default
};
